import { Card, CardContent, CardHeader, CardTitle } from '@repo/shadcn';

import { useWholesaleCustomerDetails } from './hook';

export const CustomerInfo = () => {
    const { data, isLoading, isError } = useWholesaleCustomerDetails();
    return (
        <Card>
            <CardHeader>
                <CardTitle>Customer Information</CardTitle>
            </CardHeader>
            <CardContent>
                {isLoading && <p>Loading...</p>}
                {isError && <p>Error loading customer information</p>}
                {data && (
                    <div className="space-y-2">
                        <p>
                            <strong>Name:</strong> {data?.data?.name}
                        </p>
                        <p>
                            <strong>Email:</strong> {data?.data?.email}
                        </p>
                        <p>
                            <strong>Phone Number:</strong>{' '}
                            {data?.data?.phone_number}
                        </p>
                        <p>
                            <strong>Address:</strong> {data?.data?.address}
                        </p>
                        <p>
                            <strong>Customer Type:</strong>{' '}
                            {data?.data?.customer_type}
                        </p>
                        <p>
                            <strong>Status:</strong> {data?.data?.status}
                        </p>
                    </div>
                )}
            </CardContent>
        </Card>
    );
};
